export default __webpack_public_path__ + "static/media/classic.7059255a.mp3";